import Api from '@/services/Api'

export default {
  /* Information */
  getInformation () {
    return Api().get('/info/')
  },
  saveInformation (info) {
    return Api().put('/info/', info)
  },

  /* Contacts */
  getContactList () {
    return Api().get('/contacts/')
  },
  saveContact (id, contact) {
    return Api().put('/contacts/' + id + '/', contact)
  },
  createContact (contact) {
    return Api().post('/contacts/', contact)
  },
  removeContact (id) {
    return Api().delete('/contacts/' + id + '/')
  }
}
